import { useEffect } from "react";
import AlertMessage from "@/components/alert-message/AlertMessage";

interface ProblemMessageProps {
  closeMessage: () => void;
  error: string;
  titleLabel?: "aProblem" | "error";
  textData?: string[];
}

const ProblemMessage = ({
  closeMessage,
  error,
  titleLabel = "aProblem",
  textData,
}: ProblemMessageProps) => {
  useEffect(() => {
    const timer: NodeJS.Timeout = setTimeout(() => {
      closeMessage();
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full md:w-fit md:max-w-full fixed top-[30px] right-1/2 transform translate-x-1/2 z-[1000]">
      <AlertMessage
        titleLabel={titleLabel}
        textLabel={error}
        contentType="error"
        formatType="feedback"
        onClose={closeMessage}
        textData={textData}
      />
    </div>
  );
};

export default ProblemMessage;
